// Common English words for memorable passphrase generation
// Using EFF's short wordlist approach - words selected for being memorable and unambiguous
export const WORD_LIST = [
  "able",
  "acid",
  "aged",
  "also",
  "area",
  "army",
  "away",
  "baby",
  "back",
  "ball",
  "band",
  "bank",
  "base",
  "bath",
  "bear",
  "beat",
  "been",
  "beer",
  "bell",
  "belt",
  "best",
  "bill",
  "bird",
  "blow",
  "blue",
  "boat",
  "body",
  "bomb",
  "bond",
  "bone",
  "book",
  "boom",
  "born",
  "boss",
  "both",
  "bowl",
  "bulk",
  "burn",
  "bush",
  "busy",
  "call",
  "calm",
  "came",
  "camp",
  "card",
  "care",
  "case",
  "cash",
  "cast",
  "cell",
  "chat",
  "chef",
  "chin",
  "chip",
  "city",
  "clay",
  "clip",
  "club",
  "coal",
  "coat",
  "code",
  "coin",
  "cold",
  "come",
  "cook",
  "cool",
  "cope",
  "copy",
  "cord",
  "core",
  "corn",
  "cost",
  "crab",
  "crew",
  "crop",
  "cruz",
  "cure",
  "dark",
  "data",
  "date",
  "dawn",
  "days",
  "dead",
  "deal",
  "dean",
  "dear",
  "debt",
  "deck",
  "deep",
  "deer",
  "demo",
  "deny",
  "desk",
  "dial",
  "dice",
  "died",
  "diet",
  "disc",
  "dish",
  "disk",
  "dive",
  "dock",
  "does",
  "doll",
  "door",
  "dose",
  "down",
  "drag",
  "draw",
  "drew",
  "drop",
  "drug",
  "drum",
  "duck",
  "duke",
  "dumb",
  "dump",
  "dusk",
  "dust",
  "duty",
  "each",
  "earl",
  "earn",
  "ease",
  "east",
  "easy",
  "echo",
  "edge",
  "edit",
  "else",
  "even",
  "ever",
  "evil",
  "exit",
  "face",
  "fact",
  "fade",
  "fail",
  "fair",
  "fall",
  "fame",
  "farm",
  "fast",
  "fate",
  "fear",
  "feed",
  "feel",
  "feet",
  "fell",
  "felt",
  "file",
  "fill",
  "film",
  "find",
  "fine",
  "fire",
  "firm",
  "fish",
  "fist",
  "five",
  "flag",
  "flat",
  "flew",
  "flex",
  "flip",
  "flow",
  "folk",
  "food",
  "fool",
  "foot",
  "ford",
  "fork",
  "form",
  "fort",
  "four",
  "free",
  "from",
  "fuel",
  "full",
  "fund",
  "gain",
  "game",
  "gate",
  "gave",
  "gear",
  "gene",
  "gift",
  "girl",
  "give",
  "glad",
  "glow",
  "goal",
  "goes",
  "gold",
  "golf",
  "gone",
  "good",
  "gray",
  "grew",
  "grey",
  "grid",
  "grin",
  "grip",
  "grow",
  "gulf",
  "hair",
  "half",
  "hall",
  "hand",
  "hang",
  "hard",
  "harm",
  "hate",
  "have",
  "head",
  "hear",
  "heat",
  "held",
  "hell",
  "help",
  "here",
  "hero",
  "hide",
  "high",
  "hill",
  "hint",
  "hire",
  "hold",
  "hole",
  "holy",
  "home",
  "hope",
  "horn",
  "host",
  "hour",
  "huge",
  "hung",
  "hunt",
  "hurt",
  "icon",
  "idea",
  "inch",
  "into",
  "iron",
  "item",
  "jack",
  "jail",
  "jane",
  "jazz",
  "jean",
  "john",
  "join",
  "joke",
  "juan",
  "judge",
  "july",
  "jump",
  "june",
  "jury",
  "just",
  "keen",
  "keep",
  "kent",
  "kept",
  "kick",
  "kill",
  "kind",
  "king",
  "kiss",
  "knee",
  "knew",
  "know",
  "lack",
  "lady",
  "laid",
  "lake",
  "land",
  "lane",
  "last",
  "late",
  "lead",
  "leaf",
  "lean",
  "left",
  "less",
  "lied",
  "life",
  "lift",
  "like",
  "line",
  "link",
  "lion",
  "list",
  "live",
  "load",
  "loan",
  "lock",
  "long",
  "look",
  "loop",
  "lord",
  "lose",
  "loss",
  "lost",
  "loud",
  "love",
  "luck",
  "lucy",
  "lung",
  "made",
  "mail",
  "main",
  "make",
  "male",
  "mall",
  "many",
  "mark",
  "mars",
  "mary",
  "mask",
  "mass",
  "mate",
  "math",
  "mayo",
  "maze",
  "meal",
  "mean",
  "meat",
  "meet",
  "menu",
  "mere",
  "mesa",
  "mesh",
  "mess",
  "mice",
  "mike",
  "mild",
  "mile",
  "milk",
  "mill",
  "mind",
  "mine",
  "mini",
  "mint",
  "miss",
  "mode",
  "mood",
  "moon",
  "more",
  "most",
  "move",
  "much",
  "myth",
  "nail",
  "name",
  "navy",
  "near",
  "neck",
  "need",
  "neil",
  "nest",
  "news",
  "next",
  "nice",
  "nick",
  "nine",
  "node",
  "none",
  "noon",
  "norm",
  "nose",
  "note",
  "nova",
  "nurse",
  "oath",
  "obey",
  "ohio",
  "okay",
  "once",
  "only",
  "onto",
  "open",
  "oral",
  "oven",
  "over",
  "pace",
  "pack",
  "page",
  "paid",
  "pain",
  "pair",
  "palm",
  "park",
  "part",
  "pass",
  "past",
  "path",
  "paul",
  "peak",
  "pick",
  "pill",
  "pine",
  "pink",
  "pipe",
  "plan",
  "play",
  "plot",
  "plug",
  "plus",
  "poem",
  "poet",
  "pole",
  "poll",
  "pond",
  "pool",
  "poor",
  "port",
  "pose",
  "post",
  "pour",
  "pray",
  "prep",
  "prev",
  "prey",
  "pull",
  "pump",
  "pure",
  "push",
  "quit",
  "race",
  "rail",
  "rain",
  "rank",
  "rare",
  "rate",
  "read",
  "real",
  "rear",
  "rely",
  "rent",
  "rest",
  "rice",
  "rich",
  "rick",
  "ride",
  "ring",
  "rise",
  "risk",
  "road",
  "rock",
  "rode",
  "role",
  "roll",
  "rome",
  "roof",
  "room",
  "root",
  "rope",
  "rosa",
  "rose",
  "rule",
  "rush",
  "ruth",
  "safe",
  "sage",
  "said",
  "sail",
  "sale",
  "salt",
  "same",
  "sand",
  "sang",
  "sank",
  "sara",
  "save",
  "says",
  "scan",
  "scar",
  "seal",
  "seat",
  "seed",
  "seek",
  "seem",
  "seen",
  "self",
  "sell",
  "send",
  "sent",
  "sept",
  "sets",
  "shed",
  "ship",
  "shop",
  "shot",
  "show",
  "shut",
  "sick",
  "side",
  "sign",
  "silk",
  "sing",
  "sink",
  "site",
  "size",
  "skip",
  "slid",
  "slip",
  "slow",
  "snap",
  "snow",
  "soap",
  "soft",
  "soil",
  "sold",
  "sole",
  "some",
  "song",
  "soon",
  "sort",
  "soul",
  "spot",
  "star",
  "stay",
  "stem",
  "step",
  "stop",
  "such",
  "sued",
  "suit",
  "sung",
  "sunk",
  "sure",
  "surf",
  "swap",
  "swim",
  "tail",
  "take",
  "tale",
  "talk",
  "tall",
  "tank",
  "tape",
  "task",
  "taxi",
  "team",
  "tear",
  "tech",
  "tell",
  "tend",
  "term",
  "test",
  "text",
  "than",
  "that",
  "them",
  "then",
  "they",
  "thin",
  "this",
  "thus",
  "tide",
  "tied",
  "tier",
  "till",
  "time",
  "tiny",
  "tire",
  "told",
  "toll",
  "tone",
  "tons",
  "tony",
  "took",
  "tool",
  "tops",
  "tore",
  "torn",
  "tour",
  "town",
  "tray",
  "tree",
  "trek",
  "trim",
  "trio",
  "trip",
  "troy",
  "true",
  "tune",
  "turn",
  "twin",
  "type",
  "unit",
  "upon",
  "used",
  "user",
  "uses",
  "vary",
  "vast",
  "verb",
  "very",
  "vice",
  "view",
  "visa",
  "vote",
  "wade",
  "wage",
  "wait",
  "wake",
  "walk",
  "wall",
  "want",
  "ward",
  "warm",
  "warn",
  "wash",
  "wave",
  "ways",
  "weak",
  "wear",
  "week",
  "well",
  "went",
  "were",
  "west",
  "what",
  "when",
  "wide",
  "wife",
  "wild",
  "will",
  "wind",
  "wine",
  "wing",
  "wire",
  "wise",
  "wish",
  "with",
  "wolf",
  "wood",
  "word",
  "wore",
  "work",
  "worm",
  "worn",
  "wrap",
  "yard",
  "yeah",
  "year",
  "your",
  "zero",
  "zone",
  "zoom",
  "able",
  "apex",
  "arch",
  "atom",
  "axes",
  "axis",
  "barn",
  "beam",
  "beds",
  "bees",
  "bins",
  "bits",
  "bold",
  "bolt",
  "boss",
  "boys",
  "buzz",
  "cafe",
  "cans",
  "caps",
  "cars",
  "cart",
  "cats",
  "cave",
  "chef",
  "cite",
  "claw",
  "clue",
  "coil",
  "cone",
  "cozy",
  "cube",
  "cubs",
  "cuff",
  "cups",
  "curb",
  "cure",
  "cute",
  "damp",
  "dame",
  "dash",
  "daze",
  "deli",
  "dell",
  "demo",
  "dens",
  "dent",
  "dime",
  "dims",
  "dine",
  "ding",
  "dips",
  "dome",
  "dots",
  "dorm",
  "drab",
  "dune",
  "dusk",
  "earl",
  "ears",
  "ease",
  "eats",
  "egos",
  "elks",
  "epic",
  "exam",
  "fang",
  "farm",
  "fawn",
  "fern",
  "fest",
  "fins",
  "fizz",
  "flaw",
  "flux",
  "foam",
  "foes",
  "fogs",
  "foul",
  "fowl",
  "frog",
  "fury",
  "fuse",
  "fuzz",
  "gala",
  "gale",
  "garb",
  "gaps",
  "gaze",
  "gels",
  "gems",
  "gilt",
  "glen",
  "glow",
  "gnaw",
  "gown",
  "grab",
  "gulf",
  "gull",
  "guru",
  "gust",
  "hail",
  "halt",
  "hare",
  "hawk",
  "hazy",
  "helm",
  "hemp",
  "herd",
  "hike",
  "hind",
  "hive",
  "hoax",
  "hoof",
  "hook",
  "hoop",
  "hops",
  "horn",
  "hose",
  "howl",
  "hubs",
  "hull",
  "hump",
  "hymn",
  "iced",
  "idle",
  "inch",
  "iris",
  "jade",
  "jars",
  "jaws",
  "jets",
  "jolt",
  "jowl",
  "judo",
  "junk",
  "kelp",
  "kilt",
  "kink",
  "kite",
  "kiwi",
  "labs",
  "lace",
  "lacy",
  "lads",
  "lags",
  "lair",
  "lamb",
  "lame",
  "lamp",
  "laps",
  "lard",
  "lark",
  "lass",
  "lava",
  "lawn",
  "lays",
  "laze",
  "lazy",
  "lens",
  "liar",
  "lice",
  "lids",
  "lieu",
  "lime",
  "limp",
  "lisp",
  "lobe",
  "loft",
  "loom",
  "loot",
  "lore",
  "lump",
  "lung",
  "lure",
  "lurk",
  "lush",
  "lynx",
  "mare",
  "maze",
  "mesa",
  "meow",
  "mesh",
  "mice",
  "mild",
  "mime",
  "mint",
  "mire",
  "mist",
  "moan",
  "moat",
  "mobs",
  "mock",
  "mole",
  "monk",
  "mops",
  "moss",
  "moth",
  "mown",
  "mows",
  "mule",
  "mugs",
  "muse",
  "mute",
  "nape",
  "navy",
  "nest",
  "newt",
  "nods",
  "norm",
  "nuns",
  "oaks",
  "oars",
  "oats",
  "oboe",
  "odds",
  "oils",
  "oily",
  "omen",
  "ooze",
  "opal",
  "orbs",
  "orca",
  "ores",
  "ounce",
  "owls",
  "pace",
  "pact",
  "pail",
  "pane",
  "pans",
  "papa",
  "paws",
  "pear",
  "peas",
  "peat",
  "peck",
  "peek",
  "peel",
  "peer",
  "pegs",
  "pens",
  "perk",
  "perks",
  "pest",
  "pets",
  "pews",
  "pier",
  "pies",
  "pigs",
  "pike",
  "pile",
  "ping",
  "pint",
  "pion",
  "piracy",
  "pits",
  "pity",
  "plea",
  "plow",
  "ploy",
  "plum",
  "pods",
  "poke",
  "pony",
  "pore",
  "pork",
  "posh",
  "pots",
  "pouch",
  "pout",
  "pram",
  "pray",
  "prim",
  "prod",
  "prom",
  "prop",
  "prow",
  "prune",
  "pubs",
  "puff",
  "pulp",
  "puma",
  "puns",
  "puny",
  "pupa",
  "pups",
  "purr",
  "quad",
  "quake",
  "quiz",
  "rags",
  "rail",
  "rake",
  "ramp",
  "rams",
  "rant",
  "raps",
  "rasp",
  "rats",
  "rays",
  "reap",
  "rear",
  "reds",
  "reed",
  "reef",
  "reel",
  "refs",
  "rein",
  "revs",
  "ribs",
  "rids",
  "rigs",
  "rims",
  "rind",
  "riot",
  "ripe",
  "rise",
  "roam",
  "robe",
  "robs",
  "rods",
  "rogue",
  "romp",
  "rook",
  "ropes",
  "rows",
  "rubs",
  "ruby",
  "rude",
  "ruin",
  "rump",
  "rune",
  "rung",
  "runs",
  "runt",
  "ruse",
  "rust",
  "ruts",
  "sack",
  "saga",
  "sags",
  "sails",
  "sake",
  "sane",
  "sank",
  "saps",
  "sass",
  "sate",
  "sawn",
  "saws",
  "scab",
  "scam",
  "scar",
  "scow",
  "seal",
  "seam",
  "seas",
  "sect",
  "sees",
  "serf",
  "sewn",
  "sews",
  "shag",
  "sham",
  "shaw",
  "shed",
  "shim",
  "shin",
  "shod",
  "shoo",
  "shorn",
  "shot",
  "shun",
  "shut",
  "sift",
  "sill",
  "silo",
  "silt",
  "sips",
  "sire",
  "sirs",
  "sits",
  "slab",
  "slag",
  "slam",
  "slap",
  "slat",
  "slaw",
  "slay",
  "sled",
  "slew",
  "slim",
  "slit",
  "slob",
  "sloe",
  "slog",
  "slop",
  "slot",
  "slug",
  "slum",
  "slur",
  "smog",
  "snag",
  "snap",
  "snip",
  "snob",
  "snub",
  "snug",
  "soak",
  "soar",
  "sobs",
  "sock",
  "soda",
  "sofa",
  "sops",
  "sore",
  "sort",
  "sots",
  "sour",
  "sown",
  "sows",
  "span",
  "spar",
  "spat",
  "spay",
  "spec",
  "sped",
  "spew",
  "spin",
  "spit",
  "spot",
  "spud",
  "spun",
  "spur",
  "stab",
  "stag",
  "star",
  "stat",
  "stew",
  "stir",
  "stub",
  "stud",
  "stun",
  "subs",
  "such",
  "suds",
  "sued",
  "suet",
  "sulk",
  "sums",
  "sung",
  "sunk",
  "suns",
  "surf",
  "sway",
  "swab",
  "swam",
  "swan",
  "swap",
  "sway",
  "swig",
  "swim",
  "sync",
  "tabs",
  "tack",
  "tact",
  "tags",
  "tails",
  "tame",
  "tamp",
  "tang",
  "tans",
  "taps",
  "tars",
  "tart",
  "taut",
  "teak",
  "teal",
  "teas",
  "teat",
  "teen",
  "tent",
  "tern",
  "terse",
  "test",
  "thaw",
  "thee",
  "thud",
  "thus",
  "tick",
  "tide",
  "tidy",
  "tier",
  "ties",
  "tiff",
  "tilt",
  "tint",
  "tips",
  "toad",
  "toed",
  "toes",
  "toga",
  "togs",
  "toil",
  "tomb",
  "tome",
  "toms",
  "tong",
  "tons",
  "tool",
  "toot",
  "tops",
  "tore",
  "torn",
  "tort",
  "toss",
  "tote",
  "tots",
  "tour",
  "tout",
  "tows",
  "toys",
  "tram",
  "trap",
  "tray",
  "tree",
  "trek",
  "trey",
  "trim",
  "trio",
  "trod",
  "trot",
  "trow",
  "troy",
  "true",
  "tsar",
  "tuba",
  "tube",
  "tubs",
  "tuck",
  "tuft",
  "tugs",
  "tuna",
  "tune",
  "tung",
  "tuns",
  "turf",
  "turn",
  "tusk",
  "tutu",
  "twig",
  "twin",
  "twit",
  "undo",
  "unit",
  "unto",
  "upon",
  "urge",
  "urns",
  "used",
  "user",
  "uses",
  "vain",
  "vale",
  "vane",
  "vans",
  "vary",
  "vase",
  "vast",
  "vats",
  "veal",
  "veer",
  "veil",
  "vein",
  "vend",
  "vent",
  "verb",
  "vers",
  "very",
  "vest",
  "veto",
  "vets",
  "vial",
  "vice",
  "vied",
  "vies",
  "view",
  "vile",
  "vine",
  "vise",
  "void",
  "volt",
  "vote",
  "vows",
  "wade",
  "wads",
  "waft",
  "wage",
  "wail",
  "wait",
  "wake",
  "wale",
  "walk",
  "wall",
  "wand",
  "wane",
  "wans",
  "want",
  "ward",
  "ware",
  "warm",
  "warn",
  "warp",
  "wars",
  "wart",
  "wary",
  "wash",
  "wasp",
  "wave",
  "wavy",
  "waxy",
  "ways",
  "weak",
  "wean",
  "wear",
  "webs",
  "weds",
  "weed",
  "week",
  "weep",
  "weld",
  "well",
  "welt",
  "went",
  "wept",
  "were",
  "west",
  "wets",
  "wham",
  "what",
  "when",
  "whet",
  "whey",
  "whim",
  "whip",
  "whir",
  "whit",
  "whom",
  "wick",
  "wide",
  "wigs",
  "wild",
  "wile",
  "will",
  "wilt",
  "wily",
  "wimp",
  "wind",
  "wine",
  "wing",
  "wink",
  "wins",
  "winy",
  "wipe",
  "wire",
  "wiry",
  "wise",
  "wish",
  "wisp",
  "with",
  "wits",
  "woes",
  "woke",
  "woks",
  "wolf",
  "womb",
  "wont",
  "wood",
  "woof",
  "wool",
  "woos",
  "word",
  "wore",
  "work",
  "worm",
  "worn",
  "wort",
  "wove",
  "wrap",
  "wren",
  "writ",
  "yaks",
  "yams",
  "yang",
  "yank",
  "yaps",
  "yard",
  "yarn",
  "yawn",
  "yaws",
  "year",
  "yell",
  "yelp",
  "yens",
  "yeps",
  "yeti",
  "yews",
  "yids",
  "yin",
  "yips",
  "yogi",
  "yoke",
  "yolk",
  "yore",
  "your",
  "yowl",
  "yuan",
  "yuck",
  "yule",
  "yuppie",
  "zany",
  "zaps",
  "zeal",
  "zebu",
  "zeds",
  "zees",
  "zens",
  "zero",
  "zest",
  "zeta",
  "zinc",
  "zing",
  "zips",
  "zits",
  "zone",
  "zonk",
  "zoom",
  "zoos",
  "zulu",
];

/**
 * Generates a random passphrase by selecting N random words from the word list
 * @param {number} count - Number of words to select (default: 4)
 * @returns {string[]} Array of random words
 */
export function getRandomWords(count = 4) {
  const words = [];
  for (let i = 0; i < count; i++) {
    const randomIndex = Math.floor(Math.random() * WORD_LIST.length);
    words.push(WORD_LIST[randomIndex]);
  }
  return words;
}
